import React, { Component } from 'react'
import { getInformationWithData, getInformationWithDataV3 } from '../services/CABE.js' // getInformationWithDataV3 added CUSTFIX-2026-09-16
import LoadingWindow from '../components/LoadingWindow';
import { getValueCookie } from '../services/cookieService.js';
import { BsArrowRepeat } from "react-icons/bs";
import { AiOutlineFileText } from "react-icons/ai";
import { DateFormatMAS90, formatInputDateQuery } from '../functions/dateFormat.js';
import { getIndexElement } from '../functions/searchInObject.js';
import Swal from 'sweetalert2';

import axios from "axios";
import server from "../services/Connection/backEndLink";

import ModalOrders from '../components/ModalComponent';

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }
    state = {
        OrderHeaderList: [],
        OrderHeaderListFilter: [],
        showModal: false,
        OrdersInvoiced: [],
        loadingOrderDetail: false // MEJORA 2 — re-entrancy guard, see SelectOrderDetail
    }

    async getActualOrders() {
        // Clean sales order selection
        await this.props.Padre.setState({ isAlreadyInvoiced: false })

        await this.handleModalOpen()
        const data = {
            idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            SalespersonNo: getValueCookie('SalesPerson')
        }
        const data2 = {
            idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            SalespersonNo: '0000'
        }
        var proccessInformation = []


        const respuesta = await getInformationWithData('/sales/get/header', data);
        const completeList = await getInformationWithData('/sales/get/header/byDate', data2);
        const getOrdersInvoiced = await getInformationWithData('/invoice/header',{...data2, CustomerNo: '*'});
        let SOList = [];

        // Validation to show only the invoiced ALT Sales Orders
        // if(Number(getValueCookie('CompanyId')) === 3){
        //     // Get the invoiced ALT Sales Order List
        //     let data = {
        //         SalespersonNo: getValueCookie('SalesPerson'),
        //         idCompany: 6,
        //         CustomerNo: '0016027'
        //     };
        //     let invoicedALTSalesOrders = await getInformationWithData('/invoice/header', data);
            
        //     respuesta.data = respuesta.data.filter((so) => {
        //         // Keep all non-0016027 orders
        //         if(so.CustomerNo !== '0016027') {
        //             return true;
        //         }
                
        //         // For 0016027 orders, only keep if they exist in second array
        //         return invoicedALTSalesOrders.data.some(item => item.SalesOrderNo === so.SalesOrderNo); // assuming 'id' is your unique identifier
        //     });
        // }

        if(getOrdersInvoiced.status.code === 1){
            SOList = getOrdersInvoiced.data.map(order => order.SalesOrderNo)
        }

        if (respuesta.status.code === 1) {
            proccessInformation = respuesta.data.map((element) => {
                const pos=getIndexElement(completeList.data,'SalesOrderNo',element.SalesOrderNo)
                return {
                    Status: element.Status,
                    OrderNo: (element.Comment !== null && element.Comment !== 'undefined') ? element.SalesOrderNo + '-' + element.Comment : element.SalesOrderNo,
                    OrderName: element.BillToName,
                    Date: element.OrderDate,
                    SalesPerson: element.SalespersonNo,
                    OrderNameAddress: element.BillToAddress1,
                    OrderNameCity: element.BillToCity,
                    OrderNameNo: element.CustomerNo,
                    PosQue:pos!==-1?(completeList.data[pos].posicion?(completeList.data[pos].posicion):999):999
                }
            })
        }
        this.setState({ OrderHeaderList: proccessInformation, OrderHeaderListFilter: proccessInformation, OrdersInvoiced: SOList})

    }

    async SelectOrderDetail(OrderHeader) {
        // MEJORA 2 fix: guard against re-entrancy — while a selection is
        // still resolving (including the price-validation health-check
        // ladder further down), a second click on the same or another row
        // used to re-run this whole flow, generating an extra unused
        // InvoiceNo via /sales/get/correlativeV2 each time.
        if (this.state.loadingOrderDetail) return;

        if(OrderHeader.Status === 2) {
            this.setState({ loadingOrderDetail: true })
            await this.handleModalClose()

            // Optional hook so a specific parent screen can verify server
            // health BEFORE this loads the order's detail — without
            // hardcoding that check in this shared component (only
            // InvoiceV3 passes this prop today; other screens using
            // SalesOrderPicking are unaffected).
            if (this.props.onBeforeOrderLoad) {
                await this.props.onBeforeOrderLoad();
            }

            let SalesOrderNo = ""
            let OrderInfo=""
            if (OrderHeader.OrderNo) {
                let SalesOrderProvisonalNo = OrderHeader.OrderNo.split('-')
                SalesOrderNo = SalesOrderProvisonalNo.length > 1 ? SalesOrderProvisonalNo[0] : OrderHeader.OrderNo
                
                let cont=0
                SalesOrderProvisonalNo.forEach(element => {
                    if(cont>0&&cont<SalesOrderProvisonalNo.length-1){
                        OrderInfo+=element+"-"
                    }
                    if(cont===SalesOrderProvisonalNo.length-1){
                        OrderInfo+=element
                    }
                    cont++
                });
            }
    
    
            const data = {
                idCompany: Number(getValueCookie('CompanyId')),
                CustomerNo: OrderHeader.OrderNameNo,
                OrderNo: SalesOrderNo !== "" ? SalesOrderNo : OrderHeader.OrderNo,
                Status: -1,
                company: getValueCookie('Company'),
                idcompany: getValueCookie('CompanyId'),
            }
            this.ModalLoading.current.showState(true);
            const Father = this.props.Padre
            const result = await getInformationWithData('/sales/get/detail', data)
            const result2 = await getInformationWithData('/customer/getByCustomerNo', data)
            const invent = await getInformationWithData('/Items/get', data)
    
            if(this.state.OrdersInvoiced.includes(SalesOrderNo)){
                await Father.setState({ isAlreadyInvoiced: true })
            }
            
            if (getValueCookie('CompanyId') === '6') {
                data.company = 'Mayaland Atlanta'
                data.idcompany = '3'
                const inventM = await getInformationWithData('/Items/get', data);
                invent.status.code = inventM.status.code
                // 2026-08-27 fix — guard against a "successful" but
                // malformed /Items/get response. inventM.data not being an
                // array would throw "is not iterable" on the for..of below;
                // invent.data not being one would throw on .splice/.concat.
                // Same root-cause class as the Customer fix right below —
                // a status.code: 1 response doesn't guarantee usable data.
                if (Array.isArray(inventM.data) && Array.isArray(invent.data)) {
                    for (const item of inventM.data) {
                        const index = getIndexElement(invent.data, 'itemCode', item.itemCode)
                        if (index !== -1) {
                            await invent.data.splice(index, 1)
                        }
                    }
                    invent.data = invent.data.concat(inventM.data)
                }
            }
            // 2026-08-27 fix — a "successful" (status.code: 1) response from
            // either endpoint can still carry unusable data:
            // /customer/getByCustomerNo returning `data: []` left
            // temporalHeader.Customer set to undefined below
            // (result2.data[0] on an empty array) — crashing every single
            // place this screen's parent reads Invoice.Customer.CustomerNo
            // afterward with "Cannot read properties of undefined (reading
            // 'CustomerNo')". /sales/get/detail returning a malformed
            // (non-array) Tabla2 would crash immediately below on
            // .forEach(), before InvoiceV3.js's own "no visible line" check
            // even gets a chance to run. Both are now treated as a failed
            // load, same as an outright status.code failure — so
            // InvoiceV3.js's onOrderLoadFailed retry/notify flow
            // (2026-08-25) catches this too, instead of the page crashing
            // (or, for Invoice.js/InvoicesV2.js, which don't pass
            // onOrderLoadFailed, silently doing nothing — still strictly
            // safer than the crash it replaces).
            // ═══ CUSTFIX-2026-09-16 (inicio) ═══════════════════════════════
            // Corrige: Altitude facturaba al cliente equivocado (SO AL65218 y
            // otra, 2026-09-15/16) — /customer/getByCustomerNo puede traer el
            // cliente de OTRA petición si comparte la conexión WS con algo
            // más en ese instante (ver WSFIX-2026-09-16 en el backend, que
            // reduce esto pero no lo garantiza al 100%). Esta es la garantía
            // real: comparamos el cliente que regresó esa llamada contra el
            // que YA sabíamos por la propia lista de Sales Orders
            // (OrderHeader.OrderNameNo — viene de /sales/get/header, un solo
            // query hecho una vez al abrir la lista, no por cada click). Si
            // no coinciden, NO se usa el dato — se trata igual que un load
            // fallido (mismo camino de reintento/bloqueo de más abajo).
            // Opt-in vía this.props.verifyCustomerMatch — solo InvoiceV3 lo
            // manda, así que Invoice.js/InvoicesV2.js (v1/v2, congelados)
            // quedan exactamente igual que antes.
            // Para revertir: quita "&& !customerMismatch" de este if, borra
            // la declaración de customerMismatch de abajo (incluyendo el
            // bloque del respaldo en document_audit_trail), y el bloque
            // correspondiente en el "else if (onOrderLoadFailed)".
            let customerMismatch = !!(
                this.props.verifyCustomerMatch &&
                result2.data && result2.data[0] &&
                OrderHeader.OrderNameNo &&
                String(result2.data[0].CustomerNo || '').trim() !== String(OrderHeader.OrderNameNo).trim()
            );
            // Segunda comprobación, más fuerte: contra el respaldo guardado
            // en document_audit_trail al MOMENTO EN QUE SE CREÓ la SO (nunca
            // se vuelve a tocar después) — pedido explícito del usuario
            // 2026-09-16: "guardarlo en otro campo... para detectar si en
            // picking o en invoicing está cambiando el valor de customer".
            // "found: false" es normal para SOs creadas antes de este
            // cambio — no cuenta como mismatch, no hay nada que comparar.
            if (this.props.verifyCustomerMatch && result2.data && result2.data[0] && !customerMismatch) {
                try {
                    const auditCheck = await getInformationWithDataV3('/v3/audit/original-customer', {
                        docNo: SalesOrderNo,
                        idCompany: Number(getValueCookie('CompanyId')),
                    });
                    if (auditCheck && auditCheck.status && auditCheck.status.code === 1 && auditCheck.data && auditCheck.data.found) {
                        const originalCustomerNo = String(auditCheck.data.customerNo || '').trim();
                        const loadedCustomerNo = String(result2.data[0].CustomerNo || '').trim();
                        if (originalCustomerNo && originalCustomerNo !== loadedCustomerNo) {
                            customerMismatch = true;
                            console.warn(
                                '[CUSTFIX-2026-09-16] Customer mismatch vs document_audit_trail original — expected',
                                originalCustomerNo, 'got', loadedCustomerNo
                            );
                        }
                    }
                } catch (auditError) {
                    // Nunca bloquea la carga por esto — es un respaldo extra,
                    // no la fuente principal de verdad.
                    console.warn('[CUSTFIX-2026-09-16] audit/original-customer check failed (non-blocking):', auditError);
                }
            }
            if (customerMismatch) {
                console.warn(
                    '[CUSTFIX-2026-09-16] Customer mismatch on Sales Order load — expected',
                    OrderHeader.OrderNameNo, 'got', result2.data && result2.data[0] && result2.data[0].CustomerNo
                );
            }
            // ═══ CUSTFIX-2026-09-16 (fin de la condición) ═══════════════════
            if (
                result.status.code === 1 && result2.status.code === 1 &&
                result.data && Array.isArray(result.data.Tabla2) &&
                Array.isArray(result2.data) && result2.data.length > 0 &&
                !customerMismatch
            ) {
                if (this.props.nombrePadre === 'SalesOrderListInvoice') {
                    const temporalHeader = Father.state.Invoice
                    temporalHeader.SalesOrderNo = OrderHeader.OrderNo
                    temporalHeader.Customer = result2.data[0]
                    temporalHeader.Comment=OrderInfo
                    // 2026-09-01 (client's ask, InvoiceV3-only) — pull the
                    // Sales Order's own salesperson onto the Invoice, so it
                    // stays credited to whoever actually made the sale
                    // regardless of who bills it. Opt-in via
                    // pullSalesPersonFromOrder — this component is also used
                    // by Invoice.js and InvoicesV2.js (both pass the same
                    // nombrePadre="SalesOrderListInvoice"), and only
                    // InvoiceV3.js passes this prop, so their behavior is
                    // untouched. OrderHeader.SalesPerson is the SO's
                    // SalespersonNo (see getActualOrders() above, SalesPerson:
                    // element.SalespersonNo) — only present on the row-click
                    // call site (this component's own table). The retry path
                    // (InvoiceV3.js's handleSalesOrderValidationFailure(),
                    // reloading the same order after a failed price check)
                    // calls this with only {Status, OrderNo, OrderNameNo} —
                    // the OrderHeader.SalesPerson guard below leaves whatever
                    // was already set on the first successful pass untouched
                    // instead of wiping it to undefined.
                    if (this.props.pullSalesPersonFromOrder && OrderHeader.SalesPerson) {
                        temporalHeader.SalespersonNo = OrderHeader.SalesPerson
                    }
                    let table = []
                
                    result.data.Tabla2.forEach(item => {
                        
                        const index = getIndexElement(invent.data, 'itemCode', item.ItemCode)
                        let desc = ''
                        let comp = 1563
                        if (index !== -1) {
                            comp = invent.data[index].IdCompany ? invent.data[index].IdCompany : 1563
                            desc = (!(invent.data[index].completeDesc) || invent.data[index].completeDesc === "null") ? invent.data[index].abbreviatedDesc : invent.data[index].completeDesc
                        } else {
                            desc = item.ItemCodeDesc
                        }
    
                        const itemJson = {
                            itemCode: item.ItemCode,
                            abbreviatedDesc: desc,
                            upc: item.upc,
                            quantity: 0,
                            ShipWeight: Number(item.LineWeight),
                            StandardUnitCost: 0,
                            LastTotalUnitCost: 0,
                            UnitPrice: item.UnitPrice,
                            upc2: item.upc2,
                            caseupc: item.caseupc,
                            BIN: "",
                            totalWeight: Number(item.LineWeight) * Number(item.QuantityShipped),
                            Comment: "",
                            unitCost: Number(item.UnitCost),
                            quantityOrdered: item.QuantityOrdered,
                            quantityReceived: 0,
                            quantityShipped: item.QuantityShipped,
                            totalCost: Number(item.QuantityShipped) * Number(item.UnitPrice),
                            totalFreight: 0,
                            Visible: (item.QuantityOrdered !== 0 || item.QuantityShipped !== 0) ? 1 : 0,
                            BatchUnits: 0,
                            DiscountUnits: 0,
                            SuggestedDiscount: 0,
                            Pallet: item.Pallet,
                            IdCompany: comp
                        }
                        if (item.Pallet === -1) {
                            itemJson.Visible = 0
                        }
                        if(getValueCookie('CompanyId')==='3'&&data.OrderNo.startsWith("AL")){
                            if(comp===3){
                                table.push(itemJson)
                            }
                        }else{
                            table.push(itemJson)
                        }
                        
                    });
                    // No invoiceNo generation if the invoiceNo was generated previously
                    if (!Father.state.invoiceNoGenerated) {
                        await Father.ChangeSalesOrder()
                    }
                    await Father.setState({ Products: table, Invoice: temporalHeader })
                    // refreshInputs() already calls calculateTotals() internally at
                    // the end — the explicit call that used to be here right after
                    // was a pure duplicate (2026-08-20 fix). Harmless on its own,
                    // but getPriceMarginV2()/getPriceMargin() embed a fresh random
                    // number on every call (see generalFunctions.js), so calling
                    // calculateTotals() twice back-to-back made TruckingNumber
                    // visibly change mid-load even though nothing about the prices
                    // actually changed between the two calls.
                    Father.refreshInputs()

                    // Optional hook so a specific parent screen can run extra
                    // processing right after a Sales Order's data is loaded,
                    // without hardcoding that screen's logic in this shared
                    // component (only InvoiceV3 passes this prop today; other
                    // screens using SalesOrderPicking are unaffected).
                    if (this.props.onOrderLoaded) {
                        // Hide this component's own loading overlay first —
                        // the callback may show its own progress UI / modals
                        // and shouldn't have to fight over stacking with this one.
                        this.ModalLoading.current.showState(false);
                        await this.props.onOrderLoaded();
                    }
                }
                // Get shipping addresses from the selected Sales Order — this
                // is opt-in: only parents that pass these props (currently
                // only InvoiceV3) get it. Pre-existing bug fix, unrelated to
                // MEJORA 2: these used to be called unconditionally, so
                // loading a Sales Order from any other screen using this
                // component (Invoice.js, InvoicesV2.js) always threw
                // "is not a function".
                if (this.props.onAddressesLoaded) {
                    this.getCustomerAddresses(OrderHeader.OrderNameNo)
                }
                if (this.props.clearSelectedShippingAddress) {
                    this.props.clearSelectedShippingAddress()
                }
                if (this.props.disableShippingAddress) {
                    this.props.disableShippingAddress(false)
                }
            } else if (this.props.onOrderLoadFailed) {
                // 2026-08-25 — optional hook, additive: only InvoiceV3 passes
                // this today, so behavior for every other screen using this
                // component (Invoice.js, InvoicesV2.js) is unchanged. Before
                // this, a failed /sales/get/detail or /customer/getByCustomerNo
                // response left the parent with no way to know the load
                // failed at all — onOrderLoaded simply never fired.
                this.ModalLoading.current.showState(false);
                // CUSTFIX-2026-09-16 — pass a specific reason when this is a
                // customer mismatch, not just a generic connectivity failure,
                // so the alert the user sees (and any log) says what actually
                // happened. See declaration of customerMismatch above.
                await this.props.onOrderLoadFailed(
                    OrderHeader,
                    customerMismatch
                        ? 'The customer that loaded with this sales order does not match the sales order\'s own customer. This has happened before due to a data mismatch bug — do not save/print this invoice. Retrying will reload it; if it happens again, contact Support before continuing.'
                        : undefined
                );
            }
            this.ModalLoading.current.showState(false);
            this.setState({ loadingOrderDetail: false })
        } else {
            Swal.fire({
                title: 'Sales Order Not Finished',
                text: 'This sales order must be finished before continuing.',
                icon: 'error',
                confirmButtonColor: '#14398a',
                confirmButtonText: 'OK',
            })
            this.setState({ loadingOrderDetail: false })
        }
    }

    // TODO: Refactor this function because it uses in this component and when a select a unposted invoice
    // Retrieve the customer addressed just after select a sales order
    async getCustomerAddresses(customerNo) {
        const url = server.url
        const payload = {
            data: {
                companyId: getValueCookie('CompanyId'),
                customerNo
            }
        };
        let query = "/sales/get-shipping-address-for-customer";

        await axios.post(`${url}${query}`, payload).then(
            response => {
                if (this.props.onAddressesLoaded) this.props.onAddressesLoaded(response.data.data.data)
            }
        ).catch(error => {
            // console.log(error)
            if (this.props.onAddressesLoaded) this.props.onAddressesLoaded([])
        })
    }


    contiene(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }

    }

    searchSalesOrder = e => {

        let busqueda = e.target.value;


        if(busqueda){
            let orders = this.state.OrderHeaderList.filter((order_) => {
                if (((
                    this.contiene(order_.OrderNo, busqueda)||
                    this.contiene(order_.OrderName, busqueda)
                ))
                ) {
                    return order_
                } else {
                    return null
                }
            });
            this.setState({ OrderHeaderListFilter: orders });

        }else{
            let orders=this.state.OrderHeaderList
            this.setState({OrderHeaderListFilter:orders})
            
        }

        
    }

    stateClassColor(state) {
        if (state === 1) {
            return 'warning text-dark'
        } else if (state === 2) {
            return 'success'
        } else {
            return 'danger'
        }
    }
    stateInWords(state) {

        if (state === 1) {
            return 'In process'
        } else if (state === 2) {
            return 'Finished'
        } else {
            return 'Not started'
        }


    }

    handleModalOpen = async () => {
        await this.setState({ showModal: true })
    }

    handleModalClose = () => {

        this.setState({ showModal: false })
    }

    render() {
        return (
            <>
                <button type="button" disabled={this.props.disabled} hidden={this.props.hidden} className="btn purpleButton btn-lg w-100" onClick={() => this.getActualOrders()}><AiOutlineFileText /> Sales Order List</button>
                <LoadingWindow ref={this.ModalLoading} />
                <ModalOrders title={'Sales Order List'} show={this.state.showModal} close={() => this.handleModalClose()}>
                    <div className='row form-group'>
                        <div className='col-sm-12 pb-3'>
                            <div className="input-group input-group-lg flex-nowrap">
                                <input className='form-control w-75 display-inline' placeholder='Search by...' id={'salesorder_busqueda_' + this.props.nombrePadre} onKeyUp={this.searchSalesOrder} />
                                <span className="input-group-text">
                                    <button className='btn greenButton btn-lg' onClick={() => this.getActualOrders(true)}><BsArrowRepeat /></button>
                                </span>
                            </div>
                        </div>
                        <div className='col-sm-12 tableFixHead tb-1 align-middle'>
                            <table className='table table-hover'>
                                <thead className='table-dark thead'>
                                    <tr className='text-center'>
                                        <th>Status</th>
                                        <th>Order</th>
                                        <th>Customer</th>
                                        <th>Created Date</th>
                                        <th>Sales Person</th>
                                        <th>Queue Position</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.OrderHeaderListFilter.map((order, i) => (
                                            <tr onClick={() => this.SelectOrderDetail(order)} key={i}>
                                                <td className='text-center'>
                                                    <span className={"badge bg-" + this.stateClassColor(order.Status)}> {this.stateInWords(order.Status)}&nbsp;</span>
                                                    {this.state.OrdersInvoiced.includes(order.OrderNo.split('-')[0])?
                                                    <span className="badge bg-primary">Invoiced</span>
                                                    : <span></span>
                                                    }
                                                </td>
                                                <td>{order.OrderNo}
                                                </td>
                                                <td>{order.OrderName}</td>
                                                <td className='text-center'>{formatInputDateQuery(order.Date) !== "" ? formatInputDateQuery(order.Date) : DateFormatMAS90(order.Date)}</td>
                                                <td className='text-center'>{order.SalesPerson}</td>
                                                <td className='text-center'>{order.PosQue===999?'Completed':order.PosQue}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot className='tfoot'>
                                </tfoot>

                            </table>
                        </div>


                    </div>
                    
                </ModalOrders>



            </>
        )
    }
}
